import { createTheme, type MantineColorsTuple } from '@mantine/core';

// CartCritic brand colors
const brandPrimary: MantineColorsTuple = [
  '#e8f5ff',
  '#d3e7fc',
  '#a5cdf5',
  '#75b2ee',
  '#4d9be8',
  '#358ce5',
  '#2584e4',
  '#1671cb',
  '#0064b6',
  '#0056a1',
];

const brandSecondary: MantineColorsTuple = [
  '#fff4e5',
  '#ffe8cc',
  '#ffd09a',
  '#ffb564',
  '#ff9e38',
  '#ff901d',
  '#ff8810',
  '#e47500',
  '#cb6700',
  '#b15600',
];

export const theme = createTheme({
  // Brand colors
  colors: {
    brand: brandPrimary,
    accent: brandSecondary,
  },
  primaryColor: 'brand',
  primaryShade: 6,

  // Typography
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },

  // Radius
  radius: {
    xs: '0.25rem',
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
  },
  defaultRadius: 'md',

  // Spacing
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },

  // Shadows
  shadows: {
    xs: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    sm: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },

  // Component defaults
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    Card: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    PasswordInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
});
